import DonutChart from "../../../../../src/core/DonutChart";
import { Playground } from 'docz';
import * as React from 'react';
export default {
  DonutChart,
  Playground,
  React
};